<template>
    <div class="layout-group-list">
        <div class="layout-gl-content" v-for="data in groupData" :key="'group' + data.id">
            <!-- 分组组名部分 -->
            <div class="layout-gl-title dsp-flex" @click="toggleList(data.id)" v-bind:class="{ 'layout-gl-title-cur': showList[data.id]}">
                <i class="iconfont icon-xiangyou layout-gl-icon" v-bind:class="{ 'icon-xiangxia': showList[data.id]}"></i>
                <!-- 分组名和选择部分：布局需要固定宽度 -->
                <div class="layout-glt-half">
                    <p>{{data.f_name}}({{data.group_list.length}}) <i v-show="data.id != 0 && showEdit" class="iconfont icon-bianji layout-glt-icon" @click.stop="editGroup(data)"></i></p>
                    <div class="layout-glt-choose" v-show="showList[data.id]">                        
                        <span @click.stop="selectAll(data.group_list, data.id)">全选</span>
                        <span @click.stop="invertAll(data.group_list, data.id)">反选</span>   
                    </div>
                </div>
                <!-- 年月日时部分 -->
                <div class="layout-glt-note" v-show="showList[data.id]" v-bind:class="{'direct-rtl': parseInt(settingConfigData.nianyueRishi) == 1}">
                    <span class="title-span"><span v-for="string in stringArr">{{string}}</span></span>
                </div>
            </div>
            <!-- 分组列表部分 -->
            <div class="layout-gl-list-content">
                <group-virtual-list
                    v-show="showList[data.id]"
                    v-bind:groupList="data.group_list">
                </group-virtual-list>
            </div>
        </div>

        <van-dialog v-model="showUpdate" title="修改分组名" v-bind:before-close="beforeClose" show-cancel-button closeOnClickOverlay>
            <div class="create-group-input">
                <input type="text" placeholder="请输入分组名字" v-model="inputGroup" maxlength="17" v-to-focus-group-list-input='true' autofocus  />
            </div>
        </van-dialog>
    </div>
</template>

<script>
import GroupVirtualList from '../../layouts/group/GroupVirtualList.vue'
import { UTILS } from '../../modules/utils';
export default {
    name: 'GroupList',
    directives : {
        "to-focus-group-list-input" : function (el, binding) {
            if(binding.value){
                setTimeout(() => { el.focus() }, 300);
            }
        }
    },
    props: {
        showEdit: {
            type: Boolean,
            default() { return true }
        },
    },
    computed: {
        groupData(){
            return this.$store.state.group.groupData;
        },
        settingConfigData() {
            return this.$store.state.setting.settingConfigData;
        },
    },
    components: { GroupVirtualList }, 
    data(){
        return {
            inputGroup: '',
            editGroupData: {},
            showUpdate: false,
            showList: {},
            contentDivList: [],
            stringArr: ['年', '月', '日', '时'],
        }
    },
    mounted: function () {
        this.contentDivList = document.getElementsByClassName('layout-gl-list-content');
        for(var childDiv of this.contentDivList) {
            childDiv.firstChild.style.display = 'none';
        }
    },
    methods:{
        toggleList(id) {
            // 显示分组数据的交互
            var showList = this.showList;
            var tempStatus = showList[id];
            var index = UTILS.getIdIndexInObjectArray(this.groupData, id);
            var childDiv = this.contentDivList[index];
            if(tempStatus){
                childDiv.firstChild.style.display = 'none';
            }else{
                childDiv.firstChild.style.display = 'block';
            }
            this.$set(this.showList, id, !tempStatus);
        },
        // 编辑分组
        editGroup(data) {
            this.inputGroup = data.f_name;
            this.showUpdate = true;
            this.editGroupData = data;
        },
        beforeClose(action, done) {
            if (action === 'confirm') {
                if(this.inputGroup != ''){
                    if(this.editGroupData.id == 0){
                        this.$toast("未命名组不能修改名称");
                    }else{
                        this.$store.state.group.newGroupName = this.inputGroup;
                        this.$store.dispatch('group/updateGroup', this.editGroupData);
                    }
                    done();
                }else {
                    this.$toast("名称不能为空");
                    done();
                }
            } else {
                done();
            }
        },
        // 全选
        selectAll(arr, groupId) {
            var idArr = [];
            for(var i = 0; i < arr.length; i++){
                arr[i].selected = true;
                idArr.push([arr[i].id, groupId]);
            }
            this.$store.dispatch('group/addSelectedGroupList', idArr);
        },
        // 反选
        invertAll(arr, groupId) {
            var addArr = [], removeArr = [];
            for(var i = 0; i < arr.length; i++){
                arr[i].selected = !arr[i].selected;
                if(arr[i].selected){
                    addArr.push([arr[i].id, groupId]);
                }else{
                    removeArr.push([arr[i].id, groupId]);
                }
            }
            if(addArr.length > 0){
                this.$store.dispatch('group/addSelectedGroupList', addArr);
            }
            if(removeArr.length > 0){
                this.$store.dispatch('group/removeSelectedGroupList', removeArr);
            }
        }
        
    }
}
</script>